<script>
import CrudListVue from 'Arch/components/crud/CrudList.vue';
import DlqRequest from 'App/dlq/DlqRequest';
import DataTableDateColumnVue from '../arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import DlqStatusColumnVue from './components/DlqStatusColumn.vue';
import DlqEditColumnVue from './components/DlqEditColumn.vue';

export default {
  name: 'DlqList',
  extends: CrudListVue,
  data: () => ({
    requestClass: DlqRequest,
    hideDelete: true,
    hideEdit: true,
    headers: [
      {
        text: 'ID',
        value: 'id',
      },
      {
        text: 'Status',
        value: 'status',
        component: DlqStatusColumnVue,
      },
      {
        text: 'Reason',
        value: 'reason',
      },
      {
        text: 'Exchange Received',
        value: 'exchangeReceived',
      },
      {
        text: 'Queue Received',
        value: 'queueReceived',
      },
      {
        text: 'Routing Key Received',
        value: 'routingKeyReceived',
      },
      {
        text: 'payload',
        value: 'payload',
        tooltip: true,
      },
      {
        text: 'traceId',
        value: 'traceId',
      },
      {
        text: 'serialized Message Received',
        value: 'serializedMessageReceived',
      },
      {
        text: 'Retentativas',
        value: 'messageRetryCount',
      },
      {
        text: 'Data da mensagem',
        value: 'messageDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Data de criação',
        value: 'createdDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Ação',
        value: 'id',
        component: DlqEditColumnVue,
      },
    ],
  }),
};
</script>
